import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export class CameraIntegration {
  constructor(camera, orgId, userId, event) {
    // validate the camera object
    if (!camera) throw new Error('camera object is required');
    if (!camera.camProvider) throw new Error('camera.camProvider is required');
    if (!camera.location) throw new Error('camera.location is required');
    if (!orgId) throw new Error('orgId is required');
    if (!userId) throw new Error('userId is required');
    // if (!camera.event) throw new Error('camera.event is required');
    // if there is no event.time, default to now
    if (!event) this.event = { time: dayjs().format('YYYY-MM-DD HH:mm:ss') };
    else this.event = event;
    if (!this.event?.time) this.event.time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    // register is only required for some camera vendors

    this.camera = camera;
    this.orgId = orgId;
    this.userId = userId;
    this.isAuthenticated = false;

    this.commonVideoOptions = {
      autoplay: false,
      preload: 'metadata',
      muted: true,
      fluid: true,
      controls: true,
      playsinline: true,
      controlBar: {
        children: [
          'playToggle',
          'progressControl',
          'volumePanel',
          'qualitySelector',
          'fullscreenToggle',
        ],
      },
    };
  }

  checkForCredentials() {
    const accessToken = this.camera?.accessToken;
    this.isAuthenticated = !!accessToken && accessToken !== 'refresh_token_invalid' && accessToken !== 'refresh_token_not_available';
  }

  submitCredentials() {
    throw new Error('submitCredentials not implemented');
  }

  fetchVideo() {
    throw new Error('fetchVideo not implemented');
  }

  fetchThumbnails() {
    throw new Error('fetchThumbnails not implemented');
  }

  destroy() {}
}

export const contactSupportMessage = 'Please contact support for assistance.';

function capitalizeFirstLetterOfEachWord(string) {
  return string
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatTitle(title) {
  const spaceCapitalLetters = /([a-z])([A-Z|0-9])/g;
  const removeQuotes = /['"]+/g;

  const newTitle = title.replace(spaceCapitalLetters, '$1 $2').replace(removeQuotes, '');
  const formattedTitle = capitalizeFirstLetterOfEachWord(newTitle);
  return formattedTitle;
}


/**
 * Get date and time relative to which a computer's clock and timestamp values
 * @param {object} params
 * @param {string} params.format - 'milli' or 'micro'
 * @param {string} params.time - timestamp value, formatted as 'YYYY-MM-DD HH:mm:ss'
 * @param {string} params.timezone - timezone of the timestamp value
 * @param {string} [params.vendor] - camera vendor (only required for dtiq because dtiq hates us)
*/
export function epochTimeOfSelectedEvent({ format, time, timezone, vendor }) {
  if (!format) throw Error('epochTimeOfSelectedEvent: format is required');
  if (!time) throw Error('epochTimeOfSelectedEvent: time is required');
  if (vendor !== 'dtiq' && !timezone) throw Error('epochTimeOfSelectedEvent: timezone is required when not dtiq');
  if (!['milli', 'micro'].includes(format)) throw Error(`epochTimeOfSelectedEvent: format type not supported: ${format}`);

  let UTCMilliseconds;
  if (vendor === 'dtiq') UTCMilliseconds = dayjs.utc(time, 'YYYY-MM-DD HH:mm:ss', true).valueOf();
  else {
    const eventTimezone = dayjs.tz(time, 'YYYY-MM-DD HH:mm:ss', timezone);
    UTCMilliseconds = eventTimezone.tz('UTC').valueOf();
  }
  if (format === 'milli') return UTCMilliseconds;
  // if (format === 'micro') return UTCMilliseconds * 1000;
  return UTCMilliseconds * 1000;
}
